import statesData from '@/data/current_future_costs.json'
import colors from '@/styles/colors.scss'
import * as d3 from 'd3'
import _ from 'lodash'

export const metricLookup = {
  ALL_ENERGY: 'current_energy_cost',
  DRIVING: 'current_driving_cost',
  WATER_HEAT: 'current_water_heater_cost',
  SPACE_HEAT: 'current_space_heater_cost',
  COOKING: 'current_cook_and_other_cost'
}

export const futureCostMetricLookup = {
  BEST: {
    ALL_ENERGY: 'best_energy_cost',
    DRIVING: 'best_driving_cost',
    WATER_HEAT: 'best_water_heater_cost',
    SPACE_HEAT: 'best_space_heater_cost',
    COOKING: 'best_cook_and_other_cost'
  },
  BETTER: {
    ALL_ENERGY: 'better_energy_cost',
    DRIVING: 'better_driving_cost',
    WATER_HEAT: 'better_water_heater_cost',
    SPACE_HEAT: 'better_space_heater_cost',
    COOKING: 'better_cook_and_other_cost'
  },
  GOOD: {
    ALL_ENERGY: 'good_energy_cost',
    DRIVING: 'good_driving_cost',
    WATER_HEAT: 'good_water_heater_cost',
    SPACE_HEAT: 'good_space_heater_cost',
    COOKING: 'good_cook_and_other_cost'
  },
  BAU: {
    ALL_ENERGY: '2020_energy_cost',
    DRIVING: '2020_driving_cost',
    WATER_HEAT: '2020_water_heater_cost',
    SPACE_HEAT: '2020_space_heater_cost',
    COOKING: '2020_cook_and_other_cost'
  }
}

export const fuelSourceLookup = {
  GAS: 'current_costs_gas',
  NAT_GAS: 'current_costs_nat_gas',
  PROPANE: 'current_costs_propane',
  ELECTRICITY: 'current_costs_electricity',
  FO: 'current_costs_fo'
}

export const getUSCurrentCost = metric => {
  return d3.mean(
    statesData.features.map(el => el.properties[metricLookup[metric]])
  )
}

export const getStateCurrentCost = (metric, state) => {
  return statesData.features.find(el => el.properties.name === state)
    .properties[metricLookup[metric]]
}

export const getUSFutureCost = (metric, scenario) => {
  return d3.mean(
    statesData.features.map(
      el => el.properties[futureCostMetricLookup[scenario][metric]]
    )
  )
}

export const getStateFutureCost = (metric, scenario, state) => {
  return statesData.features.find(el => el.properties.name === state)
    .properties[futureCostMetricLookup[scenario][metric]]
}

export const getExtentForMetric = props => {
  const { isElectric, metric, selectedExploreView, selectedFuelType } = props
  if (selectedExploreView === 'FUELS') {
    return d3.extent(
      statesData.features.map(
        el => el.properties[fuelSourceLookup[selectedFuelType]]
      )
    )
  }
  if (!isElectric) {
    return d3.extent(
      statesData.features.map(el => el.properties[metricLookup[metric]])
    )
  } else {
    return [-12000, 12000]
  }
}

export const getColorScaleCurrent = props => {
  // props = isElectric, metric, selectedExploreView, selectedFuelType
  const extent = getExtentForMetric({
    ...props
  })

  const scale = d3.scaleSequential(d3.interpolateRdPu).domain(extent)
  return scale
}

export const getColorScaleElectrified = props => {
  // props = isElectric, metric, scenario
  const extent = getExtentForMetric({
    ...props
  })

  const scale = d3
    .scaleThreshold()
    .domain([
      -12000 * 0.75,
      -12000 * 0.5,
      -12000 * 0.25,
      -0.0001,
      0.0001,
      12000 * 0.25,
      12000 * 0.5,
      12000 * 0.75
    ])
    .range([
      colors.red4,
      colors.red3,
      colors.red2,
      colors.red1,
      colors.green1,
      colors.green2,
      colors.green3,
      colors.green4
    ])
  return scale
}

export const getWidthScale = props => {
  const extent = getExtentForMetric({ ...props })
  const scale = d3
    .scaleLinear()
    .domain(extent)
    .range([0, 100])
  return scale
}

export const getStateValueMap = props => {
  const {
    isElectric,
    selectedScenario,
    selectedMetric,
    selectedFutureMetric,
    selectedExploreView,
    selectedFuelType
  } = props

  let retVal = {}

  if (selectedExploreView === 'FUELS') {
    statesData.features.forEach(el => {
      retVal[el.properties.state_abv] =
        el.properties[fuelSourceLookup[selectedFuelType]]
    })
  } else if (isElectric) {
    statesData.features.forEach(el => {
      const futureValue =
        el.properties[
          futureCostMetricLookup[selectedScenario][selectedFutureMetric]
        ]
      const currentValue = el.properties[metricLookup[selectedMetric]]
      retVal[el.properties.state_abv] = currentValue - futureValue
    })
  } else {
    statesData.features.forEach(el => {
      retVal[el.properties.state_abv] =
        el.properties[metricLookup[selectedMetric]]
    })
  }
  return retVal
}

export const stateABVLookup = stateAbv => {
  if (!stateAbv) return null
  return statesData.features.find(el => el.properties.state_abv === stateAbv)
    .properties.state
}

export const stateNameLookup = stateName => {
  if (stateName === 'The United States') return null
  return statesData.features.find(el => el.properties.state === stateName)
    .properties.state_abv
}
